module.exports = __webpack_public_path__ + "frontend/images/agents/mr-tan-happy-xs-037271410a67cd53c9dae0ebb08cec27.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/agents/mr-tan-happy-xs.jpg
// module id = 357
// module chunks = 2